import apiClient from './client';
import { getUserId } from '../analytics';

/**
 * Get all transaction types for optimistic updates
 */
export const getTransactionTypes = async (token = null) => {
  const headers = {};
  const uid = getUserId();
  if (uid) headers['X-User-ID'] = uid;
  if (token) headers['Authorization'] = `Bearer ${token}`;
  
  const response = await apiClient.get(
    `/gettoncini/transaction-types`,
    { headers }
  );
  return response.data;
};

/**
 * Admin gettoncini adjustment (requires admin authorization)
 * First call with confirmed=false gets user info for confirmation
 * Second call with confirmed=true processes the adjustment
 */
export const adminAdjustGettoncini = async (targetEmail, amount, reason, confirmed = false, token) => {
  const headers = {};
  const uid = getUserId();
  if (uid) headers['X-User-ID'] = uid;
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const response = await apiClient.post(
    `/admin/gettoncini/adjust`,
    {
      target_email: targetEmail,
      amount: amount,
      reason: reason,
      confirmed: confirmed
    },
    { headers }
  );
  return response.data;
};
